<template>
  <b-input-group class="group-social-networks">
    <b-input-group-prepend :size="size">
      <b-dropdown
        split-variant="outline-primary"
        class="custom-dropdown flex-grow-1 flex-shrink-0"
      >
        <template #button-content>
          {{ labelSelected }}
          <font-awesome-icon
            v-if="activeIcon"
            :icon="activeIcon"
            size="sm"
            class="social-item ml-1 mr-2"
            :class="activeItem?.value"
          />
          <font-awesome-icon icon="chevron-down" class="ml-1" size="xs" />
        </template>

        <div class="custom-menu shadow-lg">
          <b-form-radio
            v-for="(item, key) in redesSociais"
            :key="key"
            v-model="rede_social.rede_social"
            :value="item.value"
            class="shadow-none cursor-pointer custom-item social-item"
            :class="item.value"
            :size="size"
          >
            <font-awesome-icon
              :icon="item.icon"
              size="lg"
              class="social-item"
            />
          </b-form-radio>
        </div>
      </b-dropdown>
    </b-input-group-prepend>
    <b-form-input
      class="pl-2"
      v-model="rede_social_value"
      @blur="checkSocialNetwork()"
      @focus="focus()"
      :state="validateState('value')"
      :size="size"
    />
    <b-input-group-append :size="size">
      <b-button
        variant="danger"
        @click="remove()"
        class="btn-remove-contato"
        :size="size"
        :disabled="disableRemove"
      >
        <font-awesome-icon icon="trash" />
      </b-button>
    </b-input-group-append>
    <b-form-invalid-feedback> URL inválida </b-form-invalid-feedback>
  </b-input-group>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

import { validationMixin } from "vuelidate";
import { url } from "vuelidate/lib/validators";

export default {
  mixins: [formControlMixin, formStateMixin, validationMixin],
  props: makePropsConfigurable(
    sortKeys({
      ...formStateProps,
      ...formControlProps,
      value: {},
      size: {
        type: String,
        default: "",
      },
      disableRemove: {
        type: Boolean,
        default: false,
      },
    })
  ),
  data: () => ({
    rede_social: {},
  }),
  computed: {
    rede_social_value: {
      set(value) {
        this.rede_social.value = value;
      },
      get() {
        return this.rede_social.value;
      },
    },
    redesSociais() {
      return [
        { value: "linkedin", icon: ["fab", "linkedin"] },
        { value: "facebook", icon: ["fab", "facebook"] },
        { value: "instagram", icon: ["fab", "instagram"] },
        { value: "twitter", icon: ["fab", "twitter"] },
        { value: "youtube", icon: ["fab", "youtube"] },
        { value: "link", icon: ["fas", "link"] },
      ];
    },
    activeItem() {
      return this.redesSociais.find(
        (item) => item.value === this.rede_social?.rede_social
      );
    },
    activeIcon() {
      return this.activeItem?.icon;
    },
    labelSelected() {
      return !!this.activeItem?.value ? `` : "Selecionar tipo...";
    },
  },
  validations: {
    rede_social: {
      value: { url },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.rede_social[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.rede_social.$touch();
      return !this.$v.rede_social.$anyError;
    },
    remove() {
      this.$emit("remove");
    },
    checkSocialNetwork() {
      if (this.value.value == "http://" || this.value.value == "https://") {
        this.value.value = "";
      }

      const getIndexOfItem = (value) => {
        return this.rede_social_value.indexOf(value + ".com");
      };

      this.redesSociais.forEach((rede_social) => {
        if (getIndexOfItem(rede_social.value) > -1) {
          this.rede_social.rede_social = rede_social.value;
        }
      });
    },
    focus() {
      if (
        this.value.value.indexOf("http://") != 0 &&
        this.value.value.indexOf("https://") != 0
      ) {
        this.value.value = "https://" + this.value.value;
      }
    },
  },
  watch: {
    value: function (value) {
      this.rede_social = value;
    },
  },
  async created() {
    this.rede_social = this.value;
  },
};
</script>

<style scoped lang="scss">
$social-networks: (
  linkedin: #0a66c2,
  facebook: #3b5998,
  twitter: #1da1f2,
  instagram: #f56040,
  youtube: #ff0000,
  link: var(--exitos),
);

.social-item {
  font-size: 1rem;

  @each $name, $color in $social-networks {
    &.#{$name} {
      --active-color: rgb(from #{$color} r g b / 0.1);
      color: #{$color};
    }
  }
}

::v-deep .custom-dropdown {
  .dropdown-toggle {
    height: 100%;
    width: 100%;
    max-width: fit-content;
    min-height: 0;
    padding: 0 0.75rem;
    box-shadow: none;
    border-radius: 0;
    border: 1px solid #cad1d7;
    color: #9098a0;
    background-color: transparent;
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
    display: inline-flex;
    align-items: center;
    font-weight: normal;

    &:hover {
      color: #666d74;
    }

    &::after {
      display: none;
    }
  }

  .dropdown-menu {
    background-color: unset;
  }

  .custom-menu {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    background-color: var(--white);
    border-radius: 0 0 0.5rem 0.5rem;

    .custom-control {
      padding: 0;
    }

    .custom-control-input {
      display: none;
    }

    .custom-control-input:checked + .custom-control-label {
      background: var(--active-color) !important;
    }

    .custom-control-label {
      padding: 0.5rem;
      width: 40px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: 180ms;
      aspect-ratio: 1;
      border-radius: 4px;

      &:hover {
        background-color: var(--active-color);
      }

      &::after,
      &::before {
        display: none;
      }

      .social-item {
        font-size: 1.25rem;
      }
    }
  }
}
</style>
